import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]


export default /*@__PURE__*/_defineComponent({
  __name: 'Bell',
  props: {
    width: {
        type: [String, Number],
        default: 31, // Default width
    },
    height: {
        type: [String, Number],
        default: 29, // Default height
    },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${Number(__props.width)+5} ${Number(__props.height)+5}`,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6 13C6 11.4087 6.63214 9.88258 7.75736 8.75736C8.88258 7.63214 10.4087 7 12 7C13.5913 7 15.1174 7.63214 16.2426 8.75736C17.3679 9.88258 18 11.4087 18 13C18 20 21 22 21 22H3C3 22 6 20 6 13Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.3008 26C10.4682 26.3044 10.7142 26.5583 11.0133 26.7352C11.3123 26.912 11.6534 27.0053 12.0008 27.0053C12.3482 27.0053 12.6892 26.912 12.9883 26.7352C13.2873 26.5583 13.5334 26.3044 13.7008 26",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))], 8, _hoisted_1))
}
}

})